import { Lock, ShieldOff, ShieldCheck, BadgeDollarSign } from "lucide-react";
import { Reveal, SectionHeader } from "@/components/Reveal";

const BADGES = [
  {
    icon: Lock,
    title: "Encrypted",
    text: "End-to-end encrypted. Your data is never sold or shared.",
  },
  {
    icon: ShieldOff,
    title: "No AI Training",
    text: "Your content is never used to train AI models. Ever.",
  },
  {
    icon: ShieldCheck,
    title: "GDPR & CCPA",
    text: "Fully compliant with all major privacy regulations.",
  },
  {
    icon: BadgeDollarSign,
    title: "30-Day Money Back",
    text: "Full refund within 30 days. No questions asked.",
  },
];

export const Security = () => (
  <section id="security" className="bg-hero-black py-24 sm:py-32" data-testid="security-section">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <SectionHeader
        dark
        chapter="06 — Trust"
        title="Security & Privacy"
        sub="Your listings, your data, your rules."
      />

      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {BADGES.map((b, i) => (
          <Reveal key={b.title} delay={i * 0.12}>
            <div
              className="group h-full rounded-md border-2 border-white/15 bg-white/5 p-8 transition-all duration-300 ease-out hover:-translate-y-2 hover:border-hero-gold"
              data-testid={`security-badge-${i + 1}`}
            >
              <div className="inline-flex rounded-md bg-hero-gold p-3 text-hero-black">
                <b.icon className="h-6 w-6" aria-hidden="true" />
              </div>
              <h3 className="mt-5 font-display text-xl font-bold uppercase tracking-wide text-white">{b.title}</h3>
              <p className="mt-2 text-base leading-relaxed text-white/70">{b.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
